import React, { useState } from 'react';
import { StyledContainer } from '../../cliam/claim-detail/styles';
import { TextLarge } from '@/components';
import { ResponsivePageLayout } from '@/components/page-layout/ResponsivePageLayout';
import { Icon } from '@/resources';
import { useForm } from 'react-hook-form';
import { FORM_SEARCH, searchDefaultValues } from './forms';
import { columns } from './columns';
import { useGetModel } from './hooks/useGetModel';
import { useModal } from '@/components/modal/hooks/useModal';
import { EditModel } from './modals/EditModel';
import { mobileBrandCodeQuery } from '@/services/react-query/optionMasterQuery';
import { SpaceBetween } from '../../manage-data/user-info/styles';
import { ContainerButton } from '../../../styles/global-style';
import ButtonExcelEmbedded from '../../../components/report-excel/ButtonExcelEmbedded';

export const ModelList = () => {
  const [modalEdit, setModalEdit] = useState(null);
  const { open: openEdit, onToggle: onToggleEdit } = useModal();

  const { data: mobileBrandList } = mobileBrandCodeQuery();
  const formSearchObj = useForm({ defaultValues: searchDefaultValues });
  const formSearch = FORM_SEARCH({ mobileBrandList });

  const {
    dataSource,
    onFetch,
    loading: isLoadingModelList,
  } = useGetModel({
    handleSubmit: formSearchObj.handleSubmit,
  });

  const onEdit = (record) => {
    setModalEdit(record);
    onToggleEdit({ defaultValues: record });
  };

  return (
    <div>
      <StyledContainer>
        <TextLarge>รุ่นมือถือ</TextLarge>
        <ResponsivePageLayout
          searchLayout={{
            title: 'ค้นหารุ่นมือถือ',
            formSearch,
            useFormParam: formSearchObj,
            icon: <Icon.todo />,
            ignoreDateEmpty: true,
            onSearch: onFetch,
          }}
          tableLayout={{
            columns: columns({ onEdit }),
            dataSource,
            hasPagination: true,
            loading: isLoadingModelList,
            extraContent: (
              <SpaceBetween>
                <ContainerButton right>
                  <ButtonExcelEmbedded
                    header={columns({ onEdit })}
                    data={dataSource}
                    filename="รายงานรุ่นมือถือ"
                    title="Export"
                  />
                </ContainerButton>
              </SpaceBetween>
            ),
          }}
        />
        {openEdit && (
          <EditModel
            open={openEdit}
            onToggle={onToggleEdit}
            onFetch={onFetch}
            initialValues={modalEdit}
          />
        )}
      </StyledContainer>
    </div>
  );
};
